import { Autocomplete, Box } from "@mui/material";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import { MecordColors } from "Constants/Color";
import { autocompleteDropdownStyles } from "Constants/Style";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";

interface SupplierOption {
  supplier_id: string;
  supplier_name: string;
  email: string;
  phone_number: string;
  contact_person_name: string | null;
  contact_person_email: string | null;
  contact_person_phone_no: string | null;
  basic_details?: Array<{
    branch_contact_name: string;
    contact_person_email: string;
    contact_person_phone_no: string;
    branch_email: string;
    phone_no: string;
  }>;
}



interface SupplierFormValues {
  supplier: SupplierOption | null;
  contact_details: any;
}

const SupplierDetails: React.FC<{
  formik: any;
  pr_data: any;
  pr_supplier_data: any;
  branchOptions: any;
}> = ({ formik, pr_data, pr_supplier_data, branchOptions }) => {


  return (
    <div
      className="p-3 border rounded bg-opacity-10 mb-1"
      style={{ background: MecordColors?.LightThemeBGColor, border: `1px solid ${MecordColors?.LightThemeBGColor}` }}
    >
      <Row>
        <Col lg={6} className="mb-3">
          <Form.Label className="fw-semibold">
            Supplier<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            placeholder="Enter Supplier name"
            type="text"
            value={pr_supplier_data?.supplier_name || ""}
            disabled
            style={{ backgroundColor: "#ffffff", color: '#000' }}
          />
        </Col>

        <Col lg={6} className="mb-3">
          <Form.Label className="fw-semibold">
            Supplier Type
          </Form.Label>
          <Form.Control
            type="text"
            value={pr_supplier_data?.supplier_type}
            placeholder="Auto-filled"
            disabled
            style={{ backgroundColor: "#ffffff", color: '#000' }}
          />
        </Col>

        <Col lg={6} className="mb-3">
          <Form.Label className="fw-semibold">
            Email
          </Form.Label>
          <Form.Control
            type="text"
            value={pr_supplier_data?.email || ""}
            placeholder="Auto-filled"
            disabled
            style={{ backgroundColor: "#ffffff", color: '#000' }}
          />
        </Col>

        <Col lg={6} className="mb-3">
          <Form.Label className="fw-semibold">
            Phone Number
          </Form.Label>
          <Form.Control
            type="text"
            value={pr_supplier_data?.phone_number || ""}
            placeholder="Auto-filled"
            disabled
            style={{ backgroundColor: "#ffffff", color: '#000' }}
          />
        </Col>
        <Col lg={6} className="mb-3">
          <Form.Label className="fw-semibold">
            Contact Person Name
          </Form.Label>
          <Form.Control
            type="text"
            value={pr_supplier_data?.contact_person_name || ""}
            placeholder="Auto-filled"
            disabled
            style={{ backgroundColor: "#ffffff", color: '#000' }}
          />
        </Col>
            <Col lg={6} className="mb-3">
          <Form.Label className="fw-semibold">
            Contact Person Phone Number
          </Form.Label>
          <Form.Control
            type="text"
            value={pr_supplier_data?.contact_person_phone_number || ""}
            placeholder="Auto-filled"
            disabled
            style={{ backgroundColor: "#ffffff", color: '#000' }}
          />
        </Col>
        <Col lg={12} className="mb-3">
          <Form.Label className="fw-semibold">
            Contact Person Email
          </Form.Label>
          <Form.Control
            type="text"
            value={pr_supplier_data?.contact_person_email || ""}
            placeholder="Auto-filled"
            disabled
            style={{ backgroundColor: "#ffffff", color: '#000' }}
          />
        </Col>


        <Col lg={12} className="mb-0">
          <Form.Label className="fw-semibold">
            Supplier Branch<span className="text-danger">*</span>
          </Form.Label>
          <Autocomplete
            options={branchOptions}
            getOptionLabel={(option) => option.branch_name}
            value={
              branchOptions.find((opt: any) => opt.supplier_branch_id === formik.values.supplier_branch_id) || null
            }
            onChange={(event, selected) => {
              formik.setFieldValue("supplier_branch_id", selected?.supplier_branch_id || "");
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props} style={{ padding: 0 }}>
                <Box
                  sx={{
                    px: 1.5,
                    py: 0.8,
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    cursor: "pointer",

                    // ✅ Hover state
                    "&:hover": {
                      backgroundColor: MecordColors.Hover,
                      color: MecordColors.ActiveText,
                    },

                    // ✅ Selected state
                    ...(selected && {
                      backgroundColor: MecordColors.ActiveBackground,
                      color: MecordColors.ActiveText,
                    }),
                  }}
                >
                  {/* Option Label */}
                  <span>
                    {option.branch_name}
                  </span>
                </Box>
              </li>
            )}
            ListboxProps={autocompleteDropdownStyles.ListboxProps}
            renderInput={(params) => (
              <BootstrapTextField
                {...params}
                id="supplier_branch_id"
                name="supplier_branch_id"
                placeholder="Select Branch"
                error={formik.touched.supplier_branch_id && Boolean(formik.errors.supplier_branch_id)}
                helperText={formik.touched.supplier_branch_id && formik.errors.supplier_branch_id}
                fullWidth
                size="small"
                sx={{
                  ...autocompleteDropdownStyles.inputSx,
                }}
              />
            )}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#ced4da",
                },
                "&:hover fieldset": {
                  borderColor: "#ced4da",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#ced4da",
                },
              },
            }}
          />
        </Col>
      </Row>

    </div>
  );
};

export default SupplierDetails;
